var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTokenUsdt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 22C13.9778 22 15.9112 21.4135 17.5557 20.3147C19.2002 19.2159 20.4819 17.6541 21.2388 15.8268C21.9956 13.9996 22.1937 11.9889 21.8078 10.0491C21.422 8.10929 20.4696 6.32746 19.071 4.92894C17.6725 3.53041 15.8907 2.578 13.9509 2.19215C12.0111 1.8063 10.0004 2.00433 8.17313 2.76121C6.34587 3.51809 4.78409 4.79981 3.68527 6.4443C2.58646 8.08879 1.99997 10.0222 1.99997 12C1.99679 13.3141 2.25327 14.6159 2.75469 15.8306C3.25611 17.0453 3.99259 18.1489 4.92181 19.0782C5.85103 20.0074 6.95468 20.7439 8.16937 21.2453C9.38407 21.7467 10.6859 22.0032 12 22Z",
    fill: "#50AF95"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2941 13.0059C13.2218 13.0112 12.8482 13.0335 12.0153 13.0335C11.3524 13.0335 10.8824 13.0135 10.7171 13.0059C8.15589 12.8929 6.24648 12.4476 6.24648 11.9135C6.24648 11.3794 8.15825 10.9347 10.7171 10.82V12.5618C10.8847 12.5735 11.3641 12.6023 12.0271 12.6023C12.8224 12.6023 13.2206 12.5694 13.2924 12.5623V10.8212C15.8482 10.9353 17.7553 11.3806 17.7553 11.9135C17.7553 12.4465 15.8482 12.8918 13.2924 13.0053L13.2941 13.0059ZM13.2941 10.6412V9.08234H16.8606V6.70587H7.1506V9.08234H10.7165V10.6406C7.81824 10.7735 5.63824 11.3465 5.63824 12.0359C5.63824 12.7253 7.81765 13.2976 10.7165 13.4312V18.4253H13.2935V13.4294C16.1853 13.2965 18.3612 12.7235 18.3612 12.0353C18.3612 11.347 16.1847 10.7741 13.2935 10.6406L13.2941 10.6412Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenUsdt);
export default __webpack_public_path__ + "static/media/token-usdt.641979d6c10f8d33f71dfdc948c6609c.svg";
export { ForwardRef as ReactComponent };